module.exports = __webpack_public_path__ + "img/br.br33b38c3.svg";